<template>
    <div class="chat_wrap">        
        <router-view :key="$route.fullPath"/>
    </div>
</template>

<script>
export default {   
     components:{
       
    }   
}
</script>
<style scoped>
    .chat_wrap{
        height:100vh
    }
</style>
